import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import LMSCoursesBasicComponent from './course-basic-info.component';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';

export const LMSCourseComponent = ({
    selectLMSCourses, handleInnerFormChange, back, handleFormSubmit, id,learningPathCategory, libraryData, TopicsList, onFormItemChange
}: any) => {
    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '', //not used
        });
    };
    const tabItems = [
        {
            id: 1,
            title: 'Course Basic Information',
            component: <LMSCoursesBasicComponent
                handleInnerFormChange={handleInnerFormChange}
                selectLMSCourses={selectLMSCourses}
                TopicsList={TopicsList}
                libraryData={libraryData}
                learningPathCategory={learningPathCategory}


            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Media',
            component:
                <UploadMedia
                    handleInnerFormChange={handleInnerMediaFormChange}
                    mediaFilesList={selectLMSCourses?.MediaMappings?.MediaFiles}
                    ownerTypeId={1007}
                    ownerId={id}
                    folderName={'course'}
                />,
            isVisible: true,
        },
    ];

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default LMSCourseComponent;
